<template>
    <div class="flex-col">
        <vnavbar title="创建清点单" class="backbar" left-text="返回" left-arrow @click-left="back" />
        <span>选择清点流程</span>
        <div style="background: gainsboro;"><span style="font-size: x-large;">器械</span></div>
        <div v-if="qxCountingList && qxCountingList.length>0" class="scrollContent">
            <div class="content flex-col" v-if="qxCountingList && qxCountingList.length>0">
                    <vradiogroup v-model="qxvalue">
                        <vCellGroup>
                            <vCell v-for="(countingitem, index) in qxCountingList" :key="index" :title="countingitem.workflow_name" clickable @click="qxvalue = countingitem.id" style="font-size: larger;text-align: left;padding-left: 20px;">
                                <vradio slot="right-icon" :name="countingitem.id" />
                            </vCell>
                        </vCellGroup>
                    </vradiogroup>
                </div>
                <div v-else>
                    <vempty description="暂无数据" class="empty" />
                </div>
        </div>
        <div style="background: gainsboro;"><span style="font-size: x-large;">耗材</span></div>
        <div v-if="hcCountingList && hcCountingList.length>0" class="scrollContent">
            <div class="content flex-col" v-if="hcCountingList && hcCountingList.length>0">
                <vradiogroup v-model="hcvalue">
                    <vCellGroup>
                        <vCell v-for="(countingitem, index) in hcCountingList" :key="index" :title="countingitem.workflow_name" clickable @click="hcvalue = countingitem.id" style="font-size: larger;text-align: left;padding-left: 20px;">
                            <vradio slot="right-icon" :name="countingitem.id" />
                        </vCell>
                    </vCellGroup>
                </vradiogroup>
            </div>
            <div v-else>
                <vempty description="暂无数据" class="empty" />
            </div>
        </div>

        <div class="bottom">
            <vbutton class="btnTrans" type="primary" @click="createCountingFlow">确定</vbutton>
        </div>
    </div>
</template>

<script>
import { NavBar as vnavbar, PullRefresh as vpullrefresh, List as vlist, Empty, Button as vbutton, Dialog, Field as vfield, Tabbar as vtabbar, TabbarItem as vtabbaritem, Icon as vicon, Tag as vtag, Radio as vradio, RadioGroup as vradiogroup, Cell as vCell, CellGroup as vCellGroup } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `CountingSelect`,
    components: { vnavbar, vpullrefresh, vlist, Empty, vtabbar, vtabbaritem, vbutton, [Dialog.Component.name]: Dialog.Component, vfield, vicon, vtag, vradio, vradiogroup, vCell, vCellGroup },
    data() {
        return {
            surgeryId: this.$route.query.surgeryId,
            surgeryInfo: this.$route.params.surgeryInfo,
            prevPath: this.$route.params.prevPath,
            package_style: this.$root[`PackageCountingType`], // separated  combin
            loading: false,
            finished: false,
            refreshing: false,
            qxCountingList: [],
            hcCountingList: [],
            qxvalue: this.$route.params.qxvalue,
            hcvalue: this.$route.params.hcvalue
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `sysuser/workers`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`])
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.loadCountingConfig()
        })
    },
    mounted() {},
    methods: {
        generateUUID() {
            var d = new Date().getTime()
            var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16) % 16 | 0
                d = Math.floor(d / 16)
                return (c == `x` ? r : (r & 0x3 | 0x8)).toString(16)
            })
            return uuid
        },
        createCountingFlow() {
            let that = this
            return new Promise((resolve, reject) => {
                let groupName = this.generateUUID()
                let req1 = that.qxvalue > 0 && this.myaxios.post(`/api/Nursing/CountingFlow/AddOrEditFlow`, {
                    'biz_surgery_info_id': that.surgeryId,
                    'group_name': groupName,
                    'sys_counting_config_id': that.qxvalue,
                    'enum_count_type': 2
                })
                let req2 = that.hcvalue > 0 && this.myaxios.post(`/api/Nursing/CountingFlow/AddOrEditFlow`, {
                    'biz_surgery_info_id': that.surgeryId,
                    'group_name': groupName,
                    'sys_counting_config_id': that.hcvalue,
                    'enum_count_type': 1
                })
                this.myaxios.all(req1, req2).then(() => {
                    this.$router.push({ name: `CountingList`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, prevPath: this.prevPath } }).catch(err => err)
                    resolve()
                }).catch(e => { reject(e) })
            })
        },
        loadCountingConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/CountingConfig/Get`)
                req.then(countingConfigs => {
                    console.log(`countingConfigs`, countingConfigs)
                    that.hcCountingList = _.filter(countingConfigs, d => { return !d.is_deleted && d.enum_count_type == 1 })
                    that.qxCountingList = _.filter(countingConfigs, d => { return !d.is_deleted && d.enum_count_type == 2 })
                    that.qxvalue = _.find(that.qxCountingList, d => d.is_default) && _.find(that.qxCountingList, d => d.is_default).id || 0
                    that.hcvalue = _.find(that.hcCountingList, d => d.is_default) && _.find(that.hcCountingList, d => d.is_default).id || 0
                    console.log(that.allCountingList)
                    resolve()
                }).catch(e => reject(e))
            })
        },
        back() {
            this.$router.push({ name: `CountingList`, query: { surgeryId: this.surgeryId }, params: { surgeryInfo: this.surgeryInfo, prevPath: this.prevPath } }).catch(err => err)
        },
        onLoad() {
            let that = this
            that.refreshing = false
        },
        onRefresh() {
            let that = this
            that.refreshing = false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            if (newUrl.path == `/t_countingselect`) {
                this.surgeryId = this.$route.query.surgeryId
                this.surgeryInfo = this.$route.params.surgeryInfo
                this.qxvalue = this.$route.query.qxvalue
                this.hcvalue = this.$route.query.hcvalue
                this.loadCountingConfig()
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}

.line{
    margin:0px 24px;
    width:1px;
    height:130px;
    background:#EBEBEB;
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    .panel{
        position: relative;
        width: 100%;
        padding: 0 16px;
        text-align: left;
        .monthday{
            position: absolute;
            left:-40px;
            top:0px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .date{
            position: absolute;
            left:-40px;
            top:8px;
            opacity: 1;
            background: #fff;
            font-size:18px;
        }
        .step{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: start;
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
        }
        .steprowone{
            flex-basis: 70%;
            font-weight: 500;
            font-size: 20px;
            color: var(--primary-color, #009688);
            line-height: 36px;
            height: 36px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;
            white-space: nowrap;
            margin-top: 1px;
        }
        .phone{
            background-color: #E0F2EE;
            border-radius: 50%;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
        }
        .steprowtwo{
            flex-basis: 100%;
            margin-top: 5px;
        }
        .remark{
            flex-basis: 90%;
            padding: 5px 10px 10px 0px;
            background-color: rgba(245, 245, 245, 1);
            border-radius: 2px;
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/CountingSelect.vue